import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('loyaltylion'),
  titleToId: true,
  titleToNamespace: true,
  hasConnectionStatus: true,
  defaultAuthenticationType: 'oauth2Bearer',
  avatarPath: avatars.loyaltylion,
  logoPath: logos.loyaltylion
});
